var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("z-page", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "el-form",
          {
            ref: "search-form",
            staticClass: "search-form",
            attrs: {
              inline: true,
              model: _vm.searchForm,
              rules: _vm.validateForm,
            },
            nativeOn: {
              submit: function ($event) {
                $event.preventDefault()
                return (() => {}).apply(null, arguments)
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "search-from-ctrl" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "", prop: "userCode" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "用户编号", clearable: "" },
                      on: {
                        clear: function ($event) {
                          return _vm.searchPackages(true)
                        },
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchPackages(true)
                        },
                      },
                      model: {
                        value: _vm.searchForm.userCode,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.searchForm,
                            "userCode",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "searchForm.userCode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "入仓单号", clearable: "" },
                      on: {
                        clear: function ($event) {
                          return _vm.searchPackages(true)
                        },
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchPackages(true)
                        },
                      },
                      model: {
                        value: _vm.searchForm.waybill,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.searchForm,
                            "waybill",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "searchForm.waybill",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "包裹状态", prop: "packageAttrStatus" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "包裹状态" },
                        model: {
                          value: _vm.searchForm.packageAttrStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "packageAttrStatus", $$v)
                          },
                          expression: "searchForm.packageAttrStatus",
                        },
                      },
                      _vm._l(_vm.packageAttrStatusList, function (item) {
                        return _c(
                          "el-option",
                          {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          },
                          [_vm._v(" " + _vm._s(item.label) + " ")]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                !_vm.isMobile
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { clearable: "", placeholder: "用户类型" },
                            model: {
                              value: _vm.searchForm.userRole,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "userRole", $$v)
                              },
                              expression: "searchForm.userRole",
                            },
                          },
                          _vm._l(_vm.userRoles, function (item) {
                            return _c("el-option", {
                              key: item.role,
                              attrs: { label: item.name, value: item.role },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "search-from-ctrl" },
              [
                !_vm.isMobile
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "作业时间" } },
                      [
                        _c(
                          "template",
                          { slot: "label" },
                          [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.searchForm.timeType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "timeType", $$v)
                                  },
                                  expression: "searchForm.timeType",
                                },
                              },
                              [
                                _c(
                                  "el-option",
                                  {
                                    attrs: {
                                      value: "jobline_time",
                                      label: "作业时间",
                                    },
                                  },
                                  [_vm._v("作业时间")]
                                ),
                                _c(
                                  "el-option",
                                  {
                                    attrs: {
                                      value: "order_time",
                                      label: "下单时间",
                                    },
                                  },
                                  [_vm._v(" 下单时间")]
                                ),
                                _c(
                                  "el-option",
                                  {
                                    attrs: {
                                      value: "package_attr_update_time",
                                      label: "更新时间",
                                    },
                                  },
                                  [_vm._v(" 更新时间")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetimerange",
                            "picker-options": _vm.pickerOptions,
                            format: "yyyy-MM-dd HH:mm:ss",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            align: "right",
                            "default-time": ["00:00:00", "23:59:59"],
                          },
                          model: {
                            value: _vm.searchForm.dateTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "dateTime", $$v)
                            },
                            expression: "searchForm.dateTime",
                          },
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "z-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.searchPackages(true)
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c("z-button", { on: { click: _vm.resetSearch } }, [
                      _vm._v("重置"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.isLoading,
            expression: "isLoading",
          },
        ],
        staticClass: "content",
      },
      [
        _c("el-row", { attrs: { gutter: 30, span: 24 } }, [
          _c(
            "div",
            { staticClass: "ctrl" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    plain: "",
                    size: "medium",
                    disabled: !_vm.selectedRows.length,
                    border: "",
                    icon: "el-icon-printer",
                  },
                  on: { click: _vm.printPackages },
                },
                [_vm._v("打印面单")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    plain: "",
                    size: "medium",
                    disabled: !_vm.selectedRows.length,
                    border: "",
                    icon: "el-icon-printer",
                  },
                  on: { click: _vm.printLabels },
                },
                [_vm._v("打印面单(含备注)")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "container info-card" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.packages,
                    "highlight-current-row": true,
                    stripe: true,
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "",
                      prop: "package_num",
                      label: "订单单号",
                      width: "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                attrs: {
                                  type: "primary",
                                  underline: false,
                                  target: "_blank",
                                  href: `/dashboard?logistics_code=${scope.row.package_num}`,
                                },
                              },
                              [_vm._v(_vm._s(scope.row.package_num))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "package_attr.package_attr_num",
                      label: "包裹单号",
                      width: "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                attrs: {
                                  type: "primary",
                                  underline: false,
                                  target: "_blank",
                                  href: `/dashboard?logistics_code=${scope.row.package_attr.package_attr_num}`,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.package_attr.package_attr_num
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "express_title",
                      label: "用户编码",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " + _vm._s(scope.row.user.code || "-") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "收件人信息",
                      "min-width": "250",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("p", [
                              _vm._v(
                                _vm._s(scope.row.firstname) +
                                  " " +
                                  _vm._s(scope.row.last_name)
                              ),
                            ]),
                            _c("p", [_vm._v(_vm._s(scope.row.mobile))]),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(scope.row.address1) +
                                  " " +
                                  _vm._s(scope.row.address2 || "") +
                                  ", " +
                                  _vm._s(scope.row.city) +
                                  ", " +
                                  _vm._s(scope.row.state) +
                                  " " +
                                  _vm._s(scope.row.zipcode) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "包裹信息", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.package_attr.weight
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      " 尺寸：" +
                                        _vm._s(
                                          scope.row.package_attr.length +
                                            "x" +
                                            scope.row.package_attr.width +
                                            "x" +
                                            scope.row.package_attr.height
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      " 重量：" +
                                        _vm._s(
                                          (
                                            scope.row.package_attr.weight / 1000
                                          ).toFixed(3)
                                        ) +
                                        "千克 "
                                    ),
                                  ]),
                                ])
                              : _c("div", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "package_code",
                      formatter: (row, column, cellValue) =>
                        cellValue ? cellValue : "-",
                      label: "入仓单号",
                      "min-width": "250",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.logistics_code
                              ? _c("div", [
                                  _c("p", [_vm._v("承运商：" + _vm._s("-"))]),
                                  _c(
                                    "p",
                                    [
                                      _vm._v(" 承运单号："),
                                      _c(
                                        "el-link",
                                        {
                                          attrs: {
                                            type: "primary",
                                            target: "_blank",
                                            href:
                                              "/dashboard?logistics_code=" +
                                              scope.row.logistics_code,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.logistics_code || "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _c("div", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "created", label: "时间", width: "260" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                "下单时间： " +
                                  _vm._s(
                                    _vm._f("formatDate")(scope.row.created)
                                  )
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                " 作业时间： " +
                                  _vm._s(
                                    _vm._f("formatDate")(
                                      scope.row.package_attr.jobline_time
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                " 更新时间： " +
                                  _vm._s(
                                    _vm._f("formatDate")(
                                      scope.row.package_attr.updated
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "status", label: "包裹状态", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.package_attr.package_attr_num
                              ? [
                                  scope.row.package_attr.status === 2
                                    ? _c(
                                        "el-tag",
                                        { attrs: { size: "mini" } },
                                        [_vm._v("已创建")]
                                      )
                                    : _vm._e(),
                                  scope.row.package_attr.status === 6
                                    ? _c(
                                        "el-tag",
                                        { attrs: { size: "mini" } },
                                        [_vm._v("已检查")]
                                      )
                                    : _vm._e(),
                                  scope.row.package_attr.status === 1
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "success",
                                            size: "mini",
                                          },
                                        },
                                        [_vm._v("正常")]
                                      )
                                    : _vm._e(),
                                  scope.row.package_attr.status === 0
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: { size: "mini", type: "info" },
                                        },
                                        [_vm._v("已取消")]
                                      )
                                    : _vm._e(),
                                  scope.row.package_attr.status === 3
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "warning",
                                            size: "mini",
                                          },
                                        },
                                        [_vm._v("异常")]
                                      )
                                    : _vm._e(),
                                  scope.row.package_attr.status === 4
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "warning",
                                            size: "mini",
                                          },
                                        },
                                        [_vm._v("待取消")]
                                      )
                                    : _vm._e(),
                                  scope.row.package_attr.status === 5
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "warning",
                                            size: "mini",
                                          },
                                        },
                                        [_vm._v("待合包")]
                                      )
                                    : _vm._e(),
                                ]
                              : [
                                  scope.row.status === 0
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: { size: "mini", type: "info" },
                                        },
                                        [_vm._v("已取消")]
                                      )
                                    : _vm._e(),
                                  scope.row.status === 5
                                    ? _c(
                                        "el-tag",
                                        { attrs: { size: "mini" } },
                                        [_vm._v("待合包")]
                                      )
                                    : _vm._e(),
                                  scope.row.status === 6
                                    ? _c(
                                        "el-tag",
                                        { attrs: { size: "mini" } },
                                        [_vm._v("已检查")]
                                      )
                                    : _vm._e(),
                                  scope.row.status === 2
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "success",
                                            size: "mini",
                                          },
                                        },
                                        [_vm._v("待作业")]
                                      )
                                    : _vm._e(),
                                ],
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "package_attr",
                      label: "包裹图片",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row._images.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "pkg-img-box" },
                                  [
                                    _c("el-image", {
                                      staticClass: "demo-image",
                                      staticStyle: {
                                        width: "50px",
                                        height: "50px",
                                        cursor: "pointer",
                                      },
                                      attrs: {
                                        src: scope.row._thumb,
                                        "preview-src-list": scope.row._images,
                                        fit: "cover",
                                        "initial-index":
                                          scope.row._images.length - 1,
                                        lazy: true,
                                      },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "img-count-text" },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row._images.length) +
                                            " 张"
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "admin_user_name",
                      label: "检查人",
                      width: "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.admin_user_name
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      size: "small",
                                      type: "success",
                                      effect: "dark",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.admin_user_name) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm
                                              .$confirm(
                                                "是否已检查包裹图片?<br/>如需提交请确定",
                                                "提示",
                                                {
                                                  dangerouslyUseHTMLString: true,
                                                }
                                              )
                                              .then(() =>
                                                _vm.handleCheck(scope.row)
                                              )
                                          },
                                        },
                                      },
                                      [_vm._v(" 未检查 ")]
                                    ),
                                  ],
                                  1
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "package_code",
                      formatter: (row, column, cellValue) =>
                        cellValue ? cellValue : "-",
                      label: "出库",
                      width: "220",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.package_code.stockout_company
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      " 承运商：" +
                                        _vm._s(
                                          scope.row.package_code
                                            .stockout_company || "-"
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      " 承运单号：" +
                                        _vm._s(
                                          scope.row.package_code
                                            .stockout_code || "-"
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ])
                              : _c("div", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "package_code",
                      formatter: (row, column, cellValue) =>
                        cellValue ? cellValue : "-",
                      label: "全程",
                      width: "220",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.package_code.tracking_number
                              ? _c("div", [
                                  _c("p", [_vm._v(" 承运商：中国邮政 ")]),
                                  _c(
                                    "p",
                                    [
                                      _vm._v(" 承运单号："),
                                      scope.row.package_code.tracking_number
                                        ? _c(
                                            "el-link",
                                            {
                                              attrs: {
                                                underline: false,
                                                type: "primary",
                                                target: "_blank",
                                                href:
                                                  "https://t.17track.net/zh-cn#nums=" +
                                                  scope.row.package_code
                                                    .tracking_number,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.package_code
                                                    .tracking_number
                                                )
                                              ),
                                            ]
                                          )
                                        : _c("span", [_vm._v("-")]),
                                    ],
                                    1
                                  ),
                                ])
                              : _c("div", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "package_code",
                      formatter: (row, column, cellValue) =>
                        cellValue ? cellValue : "-",
                      label: "头程",
                      width: "220",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.package_code.feeder_company
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      " 承运商：" +
                                        _vm._s(
                                          scope.row.package_code
                                            .feeder_company || "-"
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c(
                                    "p",
                                    [
                                      _vm._v(" 承运单号："),
                                      scope.row.package_code.feeder_code
                                        ? _c(
                                            "el-link",
                                            {
                                              attrs: {
                                                underline: false,
                                                type: "primary",
                                                target: "_blank",
                                                href:
                                                  "https://t.17track.net/zh-cn#nums=" +
                                                  scope.row.package_code
                                                    .feeder_code,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.package_code
                                                    .feeder_code
                                                )
                                              ),
                                            ]
                                          )
                                        : _c("span", [_vm._v("-")]),
                                    ],
                                    1
                                  ),
                                ])
                              : _c("div", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "package_code",
                      formatter: (row, column, cellValue) =>
                        cellValue ? cellValue : "-",
                      label: "尾程",
                      width: "220",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.package_code.express_company
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      " 承运商：" +
                                        _vm._s(
                                          scope.row.package_code
                                            .express_company || "-"
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c(
                                    "p",
                                    [
                                      _vm._v(" 承运单号："),
                                      scope.row.package_code.express_code
                                        ? _c(
                                            "el-link",
                                            {
                                              attrs: {
                                                underline: false,
                                                type: "primary",
                                                target: "_blank",
                                                href:
                                                  "https://t.17track.net/zh-cn#nums=" +
                                                  scope.row.package_code
                                                    .express_code,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.package_code
                                                    .express_code
                                                )
                                              ),
                                            ]
                                          )
                                        : _c("span", [_vm._v("-")]),
                                    ],
                                    1
                                  ),
                                ])
                              : _c("div", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "express_title",
                      label: "客户选择线路",
                      width: "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " + _vm._s(scope.row.express_title || "-") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "express_title",
                      label: "仓库作业线路",
                      width: "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.package_attr.express_title
                              ? _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.package_attr.express_title
                                      ) +
                                      " "
                                  ),
                                ])
                              : _c("div", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "status_pay",
                      label: "支付状态",
                      width: "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.status_pay === 2
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "info", size: "mini" } },
                                  [_vm._v("未支付")]
                                )
                              : _vm._e(),
                            scope.row.status_pay === 1
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "success", size: "mini" } },
                                  [_vm._v("已支付")]
                                )
                              : _vm._e(),
                            scope.row.status_pay === 0
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "danger", size: "mini" } },
                                  [_vm._v("已退款")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "status_track",
                      label: "物流状态",
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              { attrs: { type: "default", size: "mini" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.package_attr.status_track_label
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "declare_amount",
                      formatter: (row, column, cellValue) =>
                        cellValue ? cellValue : "-",
                      label: "申报金额(¥)",
                      width: "100",
                    },
                  }),
                ],
                1
              ),
              _c("z-pagination", {
                attrs: {
                  total: _vm.pageConfig.total,
                  "page-size": _vm.pageConfig.size,
                  "current-page": _vm.pageConfig.current_page,
                  "page-sizes": [10, 20, 50, 100],
                  layout: "sizes, prev, pager, next, jumper, total",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.pageConfig, "current_page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.pageConfig, "current_page", $event)
                  },
                  "size-change": _vm.handelSizeChange,
                },
              }),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _vm.isEmpty && this.searchForm.userCode
      ? _c("div", { staticClass: "empty" }, [
          _c("img", {
            attrs: {
              src: "https://res-cn.public.gblinker.com/gblinker/ops_assets/img_no_result.svg",
            },
          }),
          _c("p", { staticClass: "message" }, [_vm._v("未查询到此客户包裹")]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }